export const calculateSerialLinkLabel = (serialDiff: number) => {
  if (serialDiff === 0) {
    return 'Edit';
  } else if (serialDiff > 0) {
    return `${serialDiff} to select`;
  } else if (serialDiff < 0) {
    return 'Too much to select';
  }
  return '';
};
